var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSimilarEffects = function SvgSimilarEffects(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#80BEB5",
    d: "M18.438 18.602c-3.072 3.006-8.02 2.93-11.052-.169C4.354 15.335.351 10.541 3.423 7.535s12.056-3.084 15.088.014c3.031 3.099 2.999 8.048-.073 11.053"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.746,
    cy: 12.021,
    r: 5.25,
    fill: "transparent",
    stroke: "#000",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.285,
    cy: 12.021,
    r: 5.25,
    fill: "transparent",
    stroke: "#000",
    strokeWidth: 1.5
  })));
};
export default SvgSimilarEffects;